import { defineMessages } from 'react-intl';

export const profileMessages = defineMessages({
  'profile:redeem-promocode:title': {
    id: 'profile:redeem-promocode:title',
    defaultMessage: 'Redeem a Promo Code',
    description: 'Redeem a Promo Code menu item.',
  },
  'profile:refer-a-friend:title': {
    id: 'profile:refer-a-friend:title',
    defaultMessage: 'Refer a Friend',
    description: 'Refer a Friend menu item.',
  },
  'profile:receiptsButtonTitle': {
    id: 'profile:receiptsButtonTitle',
    defaultMessage: 'Receipts',
    description: 'Receipts button title on the Profile page',
  },
  'profile:walletButtonTitle': {
    id: 'profile:walletButtonTitle',
    defaultMessage: 'Wallet',
    description: 'Wallet button title on the Profile page',
  },
  'profile:pointExpirationButtonTitle': {
    id: 'profile:pointExpirationButtonTitle',
    defaultMessage: 'Point Expiration',
    description: 'Point Expiration button title on the Profile page',
  },
  'profile:preferredFuelGradeButtonTitle': {
    id: 'profile:preferredFuelGradeButtonTitle',
    defaultMessage: 'Default Fuel Grade',
    description: 'Preferred Fuel Grade button title on the Profile page',
  },
  'profile:about:supportAndFeedbackButtonTitle': {
    id: 'profile:about:supportAndFeedbackButtonTitle',
    defaultMessage: 'Support',
    description: 'Profile page > About section > Title of the item in the list',
  },
  'profile:about:privacyPolicyButtonTitle': {
    id: 'profile:about:privacyPolicyButtonTitle',
    defaultMessage: 'Privacy Policy',
    description: 'Profile page > About section > Title of the item in the list',
  },
  'profile:about:termsAndConditionsButtonTitle': {
    id: 'profile:about:termsAndConditionsButtonTitle',
    defaultMessage: 'Terms & Conditions',
    description: 'Profile page > About section > Title of the item in the list',
  },
  'profile:accountActions:deleteAccountButtonTitle': {
    id: 'profile:accountActions:deleteAccountButtonTitle',
    defaultMessage: 'Delete Account',
    description: 'Profile page > Account Actions section > Delete account button title of the item in the list',
  },
  'profile:accountActions:signOutButtonTitle': {
    id: 'profile:accountActions:signOutButtonTitle',
    defaultMessage: 'Sign Out',
    description: 'Profile page > Account Actions section > Sign Out button title of the item in the list',
  },
  'profile:accountActions:devtoolsButtonTitle': {
    id: 'profile:accountActions:devtoolsButtonTitle',
    defaultMessage: 'Devtools',
    description: 'Profile page > Account Actions section > Devtools button title of the item in the list',
  },
  'profile:accountActions:personalDataShareOptOut': {
    id: 'profile:accountActions:personalDataShareOptOut',
    defaultMessage: 'Do Not Sell or Share My Data',
    description: 'Profile page > Account Actions section > Personal Data Share Opt-Out menu item title',
  },
  'profile:cookieConsentEditing:editConsentButtonTitle': {
    id: 'profile:cookieConsentEditing:editConsentButtonTitle',
    defaultMessage: 'Change Cookie Consent',
    description: 'Profile page > Cookie Consent Editing section > Edit consent button title',
  },
  'profile:aboutSectionTitle': {
    id: 'profile:aboutSectionTitle',
    defaultMessage: 'About',
    description: 'About card title on the Profile page',
  },
  'profile:accountSection:title': {
    id: 'profile:accountSection:title',
    defaultMessage: 'Account',
    description: 'Account section title on the Profile page',
  },
  'profile:appVersionTitle': {
    id: 'profile:appVersionTitle',
    defaultMessage: 'App version: {version}',
    description: 'Profile app version title',
  },
  'profile:profileSection:subtitle': {
    id: 'profile:profileSection:subtitle',
    defaultMessage: 'Tap to view and edit your information',
    description: 'Subtitle of the Edit Profile card on the Profile page',
  },
  'profile:communicationPreference': {
    id: 'profile:communicationPreference',
    defaultMessage: 'Communication Preferences',
    description: 'Communication Preferences list item text',
  },
  'profile:productInterests': {
    id: 'profile:productInterests',
    defaultMessage: 'Product Interests',
    description: 'Product Interests list item text',
  },
  'profile:aboutActions:howDoesItWork': {
    id: 'profile:aboutActions:howDoesItWork',
    defaultMessage: 'How does it work?',
    description: 'How does it work offer title',
  },
});
